import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useStoreUnitActions } from 'src/redux/helpers';
import ModalDialog from 'src/components/ModalDialog';
import FieldsSet from 'src/components/FieldsSet';
import {
  SolutionEdgeWorkloadItem,
  SolutionEdgeWorkloadItemField,
  SolutionEdgeWorkloadRepositoryType,
} from '../../types';
import SolutionGitRepoStatus from './SolutionGitRepoStatus';
import SolutionSiteClusterInfo from './SolutionSiteClusterInfo';
import solutionsStore from '../../redux';

type Props = {
  item: SolutionEdgeWorkloadItem;
  open: boolean;
  onClose: () => void;
};

const tableStyle = {
  minHeight: 0,
};

const cellStyle = {
  border: 0,
  height: 'auto',
  padding: '0 0 2rem 0',
  wordWrap: 'break-word',
  fontSize: '16px',
};

const fields = [
  {
    id: SolutionEdgeWorkloadItemField.Name,
    label: 'Name',
  },
  {
    id: SolutionEdgeWorkloadItemField.Description,
    label: 'Description',
  },
  {
    id: SolutionEdgeWorkloadItemField.RepositoryURL,
    label: 'Repository URL',
  },
  {
    id: SolutionEdgeWorkloadItemField.BranchName,
    label: 'Branch Name',
  },
  {
    id: SolutionEdgeWorkloadItemField.GitAuthentication,
    label: 'Git Authentication',
  },
  {
    id: SolutionEdgeWorkloadItemField.HelmAuthentication,
    label: 'Helm Authentication',
  },
  {
    id: SolutionEdgeWorkloadItemField.TlsCertVerification,
    label: 'TLS Certificate',
  },
  {
    id: SolutionEdgeWorkloadItemField.Path,
    label: 'Path',
  },
  {
    id: SolutionEdgeWorkloadItemField.DeploymentStatusData,
    label: 'Status',
    Component: SolutionGitRepoStatus,
  },
  {
    id: SolutionEdgeWorkloadItemField.SiteClusters,
    label: 'Sites',
    Component: SolutionSiteClusterInfo,
  },
  {
    id: SolutionEdgeWorkloadItemField.TargetNamespace,
    label: 'Target Namespace',
  },
];

const solutionGitRepoFields = [
  ...fields,
  {
    id: SolutionEdgeWorkloadItemField.KeepResources,
    label: 'Keeping Resources after deletion',
    Component: (params) => (
      <Typography sx={{ fontSize: '16px' }}>
        {params.value === true ? 'Yes' : 'No'}
      </Typography>
    ),
  },
];

function SolutionEdgeWorkloadViewContainer({ item, open, onClose }: Props) {
  const actions = useStoreUnitActions(solutionsStore);
  const { solutionId } = useParams();

  useEffect(() => {
    actions.sites(solutionId);
  }, []);

  return (
    <ModalDialog
      title={'View Git Repository'}
      open={open}
      onClose={onClose}
      onConfirm={onClose}
      showCancelBtn={false}
      confirmBtnText={'Close'}
      maxWidth="lg"
      fullWidth
    >
      <FieldsSet
        data={item}
        fields={
          item?.gitFlag === SolutionEdgeWorkloadRepositoryType.PepsenseEdge
            ? fields
            : solutionGitRepoFields
        }
        sx={{
          wordBreak: 'break-word',
          gap: 2,
        }}
      />
    </ModalDialog>
  );
}

export default SolutionEdgeWorkloadViewContainer;
